<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g transform="translate(-1419 -643)">
      <g
        transform="translate(1419 643)"
        :stroke="color"
        stroke-width="2"
        class="stroke-svg success-fill"
      >
        <rect width="24" height="24" fill="none" rx="12" stroke="none" />
        <rect x="1" y="1" width="22" height="22" rx="11" fill="none" />
      </g>
      <g transform="translate(1429.762 648.795)">
        <circle
          :fill="color"
          cx="1"
          cy="1"
          r="1"
          transform="translate(2.238 2.205) rotate(180)"
        />
        <rect
          :fill="color"
          width="2"
          height="8"
          rx="1"
          transform="translate(2.238 12.205) rotate(180)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: ["color"],
};
</script>
